function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "get_app");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rounded",
  transform: "translate(-751.000000, -289.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Action",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "-Round-/-Action-/-get_app",
  transform: "translate(646.000000, 186.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.59,9 L15,9 L15,4 C15,3.45 14.55,3 14,3 L10,3 C9.45,3 9,3.45 9,4 L9,9 L7.41,9 C6.52,9 6.07,10.08 6.7,10.71 L11.29,15.3 C11.68,15.69 12.31,15.69 12.7,15.3 L17.29,10.71 C17.92,10.08 17.48,9 16.59,9 Z M5,19 C5,19.55 5.45,20 6,20 L18,20 C18.55,20 19,19.55 19,19 C19,18.45 18.55,18 18,18 L6,18 C5.45,18 5,18.45 5,19 Z",
  id: "\\uD83D\\uDD39Icon-Color",
  fill: "#1D1D1D"
}))))));

var SvgDownloadArrow = function SvgDownloadArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-arrow.811973ec.svg";
export { ForwardRef as ReactComponent };